import React, { useState, useEffect } from "react";
// import Cookies from "js-cookie";
import axios from "axios";
import Swal from 'sweetalert2';
import '../CSS/Userform.css';
import { ENDPOINTS } from "../Helper/endpoints";

const getCookie = (cookieName) => {
  const cookies = document.cookie.split("; ");
  for (let cookie of cookies) {
    const [name, value] = cookie.split("=");
    if (name === cookieName) return decodeURIComponent(value); }
  return null; };

const UsersForm = ({ setCurrentPage }) => {
  const [formData, setFormData] = useState({
    name: "", role: "", email: "", phone: "",
    password: "", organization_pid: "", });
  const [formErrors, setFormErrors] = useState({});
  const [submissionStatus, setSubmissionStatus] = useState("");
  
  const getOrganizationsPid = () => {
    const userSessionData = getCookie("userSession");
    if (userSessionData) {
      try {
        const parsedSessionData = JSON.parse(userSessionData);
        return parsedSessionData.data.organization_info.pid;
      } catch (e) {
        console.error("Error parsing organizations_pid from cookie:", e);
        return null; } } return null; };
  
        useEffect(() => {
    const pid = getOrganizationsPid();
    setFormData((prevData) => ({
      ...prevData,
      organization_pid: pid || "", })); }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value, }); };

  const validatePhone = (phone) => {
    const phoneRegex = /^[0-9]{10}$/;
    return phoneRegex.test(phone); };

  const handleSubmit = (e) => {
    e.preventDefault();
    let errors = {};
    if (!formData.name) errors.name = "Full Name is required.";
    if (!formData.role) errors.role = "Role is required.";
    if (!formData.email) errors.email = "Email Address is required.";
    if (!validatePhone(formData.phone)) errors.phone = "Invalid phone number.";
    if (!formData.password) errors.password = "Password is required.";
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    const organization_pid = formData.organization_pid;
    if (!organization_pid) {
      setSubmissionStatus("Organization PID not found in cookies.");
      return;
    }

    const payload = {
      name: formData.name, organizations_pid: organization_pid, role: formData.role,
      email: formData.email, contact: formData.phone, password: formData.password,
    };
    axios.post(ENDPOINTS.USER, payload, { headers: { "Content-Type": "application/json" }, })
      .then((response) => {
        Swal.fire({
          title: 'Success!', text: 'Record created successfully!',
          icon: 'success', confirmButtonText: 'Okay', customClass: { popup: 'small-swal-popup', },
          showConfirmButton: false, timer: 1500,
        }).then(() => { setCurrentPage('UserList'); }); })
      .catch((error) => {
        console.error("Error submitting form:", error);
        setSubmissionStatus("Error submitting the form. Please try again.");
        Swal.fire({
          title: 'Error!', text: 'Error submitting the form. Please try again.',
          icon: 'error', confirmButtonText: 'Okay', customClass: { popup: 'small-swal-popup', },
          showConfirmButton: false, timer: 1500, }); }); };

  return (
    <div className="user-form-container">
      <form onSubmit={handleSubmit} className="user-form">
      <i className="bi bi-arrow-left-circle-fill back-icon"
  onClick={() => { setCurrentPage("UserList"); }}
  style={{ cursor: "pointer", display: "inline-block", width: "24px",            
    height: "24px" }} ></i>
        <h2>User Information Form</h2>
        
        <input type="text" className='form-control form-control-lg'
          name="name" value={formData.name} onChange={handleChange}
          placeholder="Full Name" required />
        {formErrors.name && <span className="error-text">{formErrors.name}</span>}

        <input type="text" className='form-control form-control-lg'
          name="role" value={formData.role} onChange={handleChange}
          placeholder="Role" required />
        {formErrors.role && <span className="error-text">{formErrors.role}</span>}

        <input type="email" className="form-control form-control-lg"
          name="email" value={formData.email} onChange={handleChange}
          placeholder="Email Address" required autoComplete="off" />
        {formErrors.email && <span className="error-text">{formErrors.email}</span>}

        <input type="tel" name="phone" className='form-control form-control-lg'
          value={formData.phone} onChange={handleChange} placeholder="Phone Number"
          pattern="[0-9]*" required maxLength="10" />
        {formErrors.phone && <span className="error-text">{formErrors.phone}</span>}

        <input type="password" name="password" className="form-control form-control-lg"
          value={formData.password} onChange={handleChange}
          placeholder="Password" required autoComplete="new-password" />
        {formErrors.password && <span className="error-text">{formErrors.password}</span>}

        <button type="submit" className="submit-btn">Submit</button>
      </form>
      {submissionStatus && <p className="submission-status">{submissionStatus}</p>}
    </div>
  );
};
export default UsersForm;
